import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const LicenseLogTable = (props) => {
  const {
    tableRef,
    stickyStyle,
    tableHeader,
    currentoriginLicenseLogList,
    selectedPage,
    selectedPageLimit
  } = props;

  const { t } = useTranslation();

  return (
    <Table responsive hover className="table-container" ref={tableRef}>
      <thead style={stickyStyle}>
        <tr>
          <th>#</th>
          {tableHeader()}
        </tr>
      </thead>
      <tbody>
        {currentoriginLicenseLogList && currentoriginLicenseLogList.map((item, index) => {
          return (
            <tr key={index}>
              <td>{(selectedPage - 1) * selectedPageLimit + index + 1}</td>
              <td>{item.time}</td>
              <td>{item.account}</td>
              <td>{item.licenseKey}</td>
              <td>{t(item.actionTypeLabel)}</td>
              <td>{item.details}</td>
            </tr>
          )
        })}
        {currentoriginLicenseLogList.length === 0 && (
          <tr>
            <td colSpan="8" className="no-data">
              {t('ad01242a61')}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
  ;
}

export default LicenseLogTable;